export const environment = {
  production: false,
  identity: () => `https://auth.dev.medmio.com`,
  clientId: () => `medmio.web.portal`,
  apiUrlBase: () => `https://api.dev.medmio.com`,
  cognito: {
    userPoolId: 'us-east-1_9MhRfTZnX',
    userPoolClientId: '77fn7o7518972isaliu1j7k2d2',
    region: 'us-east-1',
  },
  featureFlags: {
    useCognito: true,
  },
};
